<!-- eslint-disable vue/no-mutating-props -->
<template>
    <div class="Görüşme Bilgi_detay">
        <AppMain>





            <div class="nk-content ">
        <div class="container-fluid">
            <div class="nk-content-inner">
                <div class="nk-content-body">
                    <div class="nk-block-head nk-block-head-sm">
                        <div class="nk-block-between g-3">
                            <div class="nk-block-head-content">

                            

                                <h3 class="nk-block-title page-title">Görüşme Bilgi  / <strong class="text-primary small">{{ gorusmebilgiler?.oncelik }}</strong></h3>
                                <div class="nk-block-des text-soft">
                                    <ul class="list-inline">
                                        <li>Görüşme Bilgi  ID: <span class="text-base">{{ gorusmebilgiler?.id }}</span></li>
                                        <li>Güncelleme Tarihi: <span class="text-base">{{ gorusmebilgiler?.duzenleme_tarih }}</span></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="nk-block-head-content">
                                <router-link to="/gorusmebilgiler"  class="btn btn-outline-light bg-white d-none d-sm-inline-flex"><em
                                        class="icon ni ni-arrow-left"></em><span>Görüşme Bilgiler</span>
                                    </router-link>
                                  </div>
                        </div>
                    </div>
                    <div class="nk-block">
                        <div class="card card-bordered">
                            <div class="card-aside-wrap">
                                <div class="card-content">
                                    <ul class="nav nav-tabs nav-tabs-mb-icon nav-tabs-card">
                                        
                                        <li class="nav-item">
                                            <a  href="#" class=" nav-link   active "
                                            @click="aktifSekmeDegistir('bilgiler')">
                                                <em class="icon ni ni-user-circle"></em>
                                                <span>Görüşme Bilgi Bilgileri</span>
                                            </a>
                                        </li>

                                        

                                        


                                   
                                    </ul>

                               
                                    <div class="card-inner" >
                                        <div class="nk-block">
                                            <div class="nk-block-head">
                                                <h5 class="title">Görüşme Bilgi Bilgileri</h5>
                                               
                                            </div>
                                            <div class="profile-ud-list">
                                                

                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Etkinlik </span><span class="profile-ud-value">{{ gorusmebilgiler?.etkinlik_ad }}</span></div>
                                                                </div>
                                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Firma </span><span class="profile-ud-value">{{ gorusmebilgiler?.firma_ad }}</span></div>
                                                                </div>
                                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Firma Yetkilisi</span><span class="profile-ud-value">{{ gorusmebilgiler?.kisi_ad }}</span></div>
                                                                </div>
                                                
                                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Görüşme Yapan</span><span class="profile-ud-value">{{ gorusmebilgiler?.gorusmeyapan_ad }}</span></div>
                                                                </div>
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Öncelik </span><span class="profile-ud-value">
                                                                        <template v-if=" gorusmebilgiler?.oncelik =='onemli'" >Önemli </template>  
                                                                        <template v-if=" gorusmebilgiler?.oncelik =='normal'" >Normal</template>  
                                                                        <template v-if=" gorusmebilgiler?.oncelik =='takipet'" >Takip Et</template>  

                                                                    </span></div>
                                                                </div>
                                    
                                                                <div class="profile-ud-item">
                                                                <div class="profile-ud wider">
                                                                    <span class="profile-ud-label">Ziyaretçi Tipi</span>
                                                                    <span class="profile-ud-value">
                                                                        <template v-if=" gorusmebilgiler?.ziyaretcitipi == 'sonkullanici'">Son Kullanıcı</template>
                                                                        <template v-if=" gorusmebilgiler?.ziyaretcitipi == 'tedarikci'">Tedarikçi</template>
                                                                        <template v-if=" gorusmebilgiler?.ziyaretcitipi == 'potansiyelbayi'">Potansiyel Bayi</template>
                                                                    </span>
                                                                </div>
                                                            </div>

                                    
                                                            <div class="profile-ud-item">
                                                            <div class="profile-ud wider">
                                                                <span class="profile-ud-label">Aktivite Tipi</span>
                                                                <span class="profile-ud-value">
                                                                    <template v-if=" gorusmebilgiler?.aktivitetipi === 'acil'">Acil</template>
                                                                    <template v-if=" gorusmebilgiler?.aktivitetipi === 'olagan'">Olağan</template>
                                                                </span>
                                                            </div>
                                                        </div>

                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Malzeme Alt Yapı </span><span class="profile-ud-value">
                                                                      <template v-if=" gorusmebilgiler?.lazer" >Lazer , </template>  
                                                                      <template v-if=" gorusmebilgiler?.plazma" >Plazma , </template>  
                                                                      <template v-if="gorusmebilgiler?.oksijen" >Oksijen , </template>  
                                                                      <template v-if="gorusmebilgiler?.punch" >Punch , </template>  
                                                                      <template v-if="gorusmebilgiler?.diger" >Diğer  </template>  
                                                                    
                                                                    </span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Taşlama Personel Sayısı </span><span class="profile-ud-value">{{ gorusmebilgiler?.taslamapersonelsayi }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Malzeme Kalınlığı Aralığı </span><span class="profile-ud-value">{{ gorusmebilgiler?.malzemekalinligiaraligi }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Malzeme Genişlik Aralığı </span><span class="profile-ud-value">{{ gorusmebilgiler?.malzemegenislikaraligi }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Malzeme Kalitesi </span><span class="profile-ud-value">{{ gorusmebilgiler?.malzemekalitesi }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Malzeme Şekli </span><span class="profile-ud-value">{{ gorusmebilgiler?.malzemesekli }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Tutucu Sistem </span><span class="profile-ud-value">{{ gorusmebilgiler?.tutucusistem }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Doğrultma Makinesi Malzeme Kalınlık Aralığı </span><span class="profile-ud-value">{{ gorusmebilgiler?.dogrultmamalzemekalinlikaraligi }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Doğrultma Maksimum Parça Genişliği </span><span class="profile-ud-value">{{ gorusmebilgiler?.dogrultmamaksimumparcagenisligi }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Doğrultma Makinesi Maksimum Malzeme Boyu </span><span class="profile-ud-value">{{ gorusmebilgiler?.dogrultmamaksimummalzemeboyu }} {{ gorusmebilgiler?.dogrultmamaksimummalzemeboyuolcu }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Doğrultma Makinesi Aranılan Düzlemsellik Toleransı </span><span class="profile-ud-value">{{ gorusmebilgiler?.dogrultmaaranilanduzlemselliktoleransi }} {{ gorusmebilgiler?.dogrultmamaksimummalzemeboyuolcu }}</span></div>
                                                                </div>
                                    
                                    
                                    <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Manuel Çapak Alma ve Kaner Yuvarlama Makinesi Noti  </span><span class="profile-ud-value">{{ gorusmebilgiler?.manuelcapakalmavekenaryuvarlamamakinesinot }}</span></div>
                                                                </div>
                                    
                                    <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Not </span><span class="profile-ud-value">{{ gorusmebilgiler?.not }}</span></div>
                                                                </div>
                                    
                                    <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Ses Kaydi </span><span class="profile-ud-value">   <audio :src="$globalVariable.uploadUrl + gorusmebilgiler?.seskaydi" controls></audio></span></div>
                                                                </div>

                                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Kartvizit Görsel Ön </span><span class="profile-ud-value">     <img 
    v-if=" gorusmebilgiler?.kartviziton" 
    class="rounded img-cover mb-2 h-50" 
    :src="$globalVariable.uploadUrl + gorusmebilgiler?.kartviziton" 
    alt="Kartvizit Ön Görsel" 
  /></span></div>
                                                                </div>

                                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Kartvizit Görsel Arka </span><span class="profile-ud-value">     <img 
    v-if=" gorusmebilgiler?.kartvizitarka" 
    class="rounded img-cover mb-2 h-50" 
    :src="$globalVariable.uploadUrl + gorusmebilgiler?.kartvizitarka" 
    alt="Kartvizit Ön Görsel" 
  /></span></div>
                                                                </div>
                                    

                                    
                               
                                    <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Tarih </span><span class="profile-ud-value">{{ gorusmebilgiler?.tarih }}</span></div>
                                                                </div>
                                    
                                                 
                                                    

                                            </div>
                                        </div>
                                        <div class="nk-block">
                                            <div class="nk-block-head nk-block-head-line">
                                                <h6 class="title overline-title text-base">Kayıt Bilgileri</h6>
                                            </div>
                                            <div class="profile-ud-list">
                                                <div class="profile-ud-item">
                                                    <div class="profile-ud wider"><span class="profile-ud-label">Oluşturma Tarihi</span><span class="profile-ud-value">{{ gorusmebilgiler?.olusturma_tarih }}</span></div>
                                                </div>
                                                <div class="profile-ud-item">
                                                    <div class="profile-ud wider"><span class="profile-ud-label">Son Düzenleme Tarihi</span><span class="profile-ud-value">{{ gorusmebilgiler?.duzenleme_tarih }}</span>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div class="nk-divider divider md"></div>
                                      
                                    </div>
                                    

                                    
                                    
                          
                             
                                      



                                </div>
                                <div class="card-aside card-aside-right user-aside toggle-slide toggle-slide-right toggle-break-xxl toggle-screen-xxl"
                                    data-content="userAside" data-toggle-screen="xxl" data-toggle-overlay="true"
                                    data-toggle-body="true">
                                    <div class="card-inner-group" data-simplebar="init">
                                        <div class="simplebar-wrapper" style="margin: 0px;">
                                            <div class="simplebar-height-auto-observer-wrapper">
                                                <div class="simplebar-height-auto-observer"></div>
                                            </div>
                                            <div class="simplebar-mask">
                                                <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                                                    <div class="simplebar-content-wrapper" tabindex="0" role="region"
                                                        aria-label="scrollable content"
                                                        style="height: auto; overflow: hidden;">
                                                        <div class="simplebar-content" style="padding: 0px;">
                                                            <div class="card-inner">
                                                                <div class="user-card user-card-s2">
                                                                    <div class="user-avatar lg bg-primary"> 
                                                                         <img :src="$globalVariable.uploadUrl + gorusmebilgiler?.logo"
                                                                            @error="$globalVariable.varsayilanGorsel" class="img-fluid rounded-xl">
                                                                        </div>
                                                                    <div class="user-info">
                                                                        <div
                                                                            class="badge bg-outline-light rounded-pill ucap">
                                                                            {{ gorusmebilgiler?.oncelik }}</div>
                                                                        <h5> {{ gorusmebilgiler?.oncelik  }}</h5><span
                                                                            class="sub-text">{{ gorusmebilgiler?.oncelik }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="card-inner card-inner-sm">
                                                                <ul class="btn-toolbar justify-center gx-1">
                                                                    <li><a href="#" class="btn btn-trigger btn-icon"><em
                                                                                class="icon ni ni-shield-off"></em></a>
                                                                    </li>
                                                                    <li><a href="#" class="btn btn-trigger btn-icon"><em
                                                                                class="icon ni ni-mail"></em></a></li>
                                                                    <li><a href="#" class="btn btn-trigger btn-icon"><em
                                                                                class="icon ni ni-download-cloud"></em></a>
                                                                    </li>
                                                                   
                                                                    <li><a href="#"
                                                                            class="btn btn-trigger btn-icon text-danger"><em
                                                                                class="icon ni ni-na"></em></a></li>
                                                                </ul>
                                                            </div>
                                                        
                                                            <div class="card-inner">
                                                                <div class="row text-center">
                                                                    <div class="col-6">
                                                                        <div class="profile-stats"><span
                                                                                class="amount">gorusmebilgiler</span><span
                                                                                class="sub-text">{{ gorusmebilgiler?.oncelik }}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-6">
                                                                        <div class="profile-stats"><span
                                                                                class="amount">gorusmebilgiler</span><span
                                                                                class="sub-text">{{ gorusmebilgiler?.oncelik }}</span>
                                                                        
                                                                    </div>
                                                                  
                                                                </div>
                                                            </div>

                                           

                                                            <div class="card-inner">
                                                                <h6 class="overline-title-alt mb-2">Kayıt Bilgileri</h6>
                                                                <div class="row g-3">
                                                                    <div class="col-6"><span class="sub-text">Oluşturma Tarihi:</span><span>{{ gorusmebilgiler?.olusturma_tarih }}</span></div>
                                                                  
                                                                    <div class="col-6"><span class="sub-text">Son Düzenleme Tarihi:</span><span>{{ gorusmebilgiler?.duzenleme_tarih }}</span></div>
                                                                </div>
                                                            </div>
                                                          
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="simplebar-placeholder" style="width: auto; height: 815px;">
                                            </div>
                                        </div>
                                        <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
                                            <div class="simplebar-scrollbar" style="width: 0px; display: none;"></div>
                                        </div>
                                        <div class="simplebar-track simplebar-vertical" style="visibility: hidden;">
                                            <div class="simplebar-scrollbar" style="height: 0px; display: none;"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
</div>









            </AppMain>
        </div>
</template>
  
<script>
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';
import AppMain from "@/components/AppMain.vue";




export default {
    name: "gorusmebilgilerDetayView",
    components: {
        AppMain,
        
    },
    data() {
        return {
            gorusmebilgiler: [],
           
         
            hareketSayfadaKayit: 10,
            hareketSeciliSayfa: 1,

            
          
            


        };
    },
    mounted() {
        this.gorusmebilgilerDetayGetir();
    },

    methods: {
        yetki_kontrol(yetki) {
            return yetkiKontrol(yetki);
        },
    
        gorusmebilgilerDetayGetir() {
            const id = this.$route.params.id;

            axiosCustom
                .get(`gorusmebilgiler/detay/${id}`)
                .then((response) => {
                    this.gorusmebilgiler = response.data;
           
                    

                    

                    
                })
                .catch((error) => {
                    console.error("Veri çekme hatası: ", error);
                });
        },

    
        aktifSekmeDegistir(sekme) {
            this.aktifSekme = sekme;
            const id = this.$route.params.id;
            this.$router.push('/gorusmebilgiler/'+id+'/'+sekme);
        },




        


       

        



    }
};
</script>
  

  